import { createGlobalStyle } from 'styled-components'

import FontWoff from './93a467f70a3e7b27a9b52a686f351dbe.woff'
// import regular from './regular.woff'
// import medium from './medium.woff'
// import bold from './bold.woff'

export default createGlobalStyle`
  @font-face {
    font-family: "din";
    src: url(${FontWoff});
  }

  @font-face {
    font-family: "imlregular";
    src: url(${FontWoff});
  }

  @font-face {
    font-family: "imlmedium";
    src: url(${FontWoff});
  }

  @font-face {
    font-family: "imlbold";
    src: url(${FontWoff});
  }
`
